import {ErrorHandler, Injectable} from '@angular/core';

import {logger} from "../utils/logger";
import {StatusCodes} from 'http-status-codes';
import {NavigationUtils} from "../utils/navigation-utils";

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor() {
  }

  private stabilizeError(error: Error): Error {
    if ('promise' in error) {
      return (error as unknown as { rejection: Error }).rejection;
    }
    return error;
  }

  handleError(error: any): void {
    error = this.stabilizeError(error.originalError || error);

    logger.error(error);
    if (!!error?.status && [StatusCodes.UNAUTHORIZED, StatusCodes.FORBIDDEN].includes(error.status)) {
      NavigationUtils.navigateToGwoLoginPage();
    }
  }
}

export const globalErrorHandler = {
  provide: ErrorHandler,
  useClass: GlobalErrorHandler,
};
